import { Preset, Period } from './IntervalField';

export const getPresetDates = (preset: Preset): { startDate: Date; endDate: Date } => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = now.getUTCMonth();
  const dayNumber = now.getUTCDate();

  const endOfToday = new Date(year, month, dayNumber, 23, 59, 59);
  const dayOfTheWeek = now.getUTCDay();
  const at30DaysBefore = new Date(year, month, dayNumber - 30);

  switch (preset) {
    case 'today':
      return { startDate: new Date(year, month, dayNumber), endDate: endOfToday };

    case 'yesterday':
      return {
        startDate: new Date(year, month, dayNumber - 1),
        endDate: new Date(year, month, dayNumber - 1, 23, 59, 59),
      };
    case 'weekToDate':
      return { startDate: new Date(year, month, dayNumber - now.getDay() + 1), endDate: endOfToday };

    case 'lastWeek':
      return {
        startDate: new Date(year, month, dayNumber - dayOfTheWeek - 6),
        endDate: new Date(year, month, dayNumber - dayOfTheWeek, 23, 59, 59),
      };

    case 'monthToDate':
      return { startDate: new Date(new Date().setDate(1)), endDate: endOfToday };

    case 'lastMonth':
      return {
        startDate: new Date(year, month - 1, 1),
        endDate: new Date(year, month - 1, new Date(year, month, 0).getDate(), 23, 59, 59),
      };

    case 'last30Days':
      return { startDate: at30DaysBefore, endDate: now };

    case 'yearToDate':
      return { startDate: new Date(new Date().getFullYear(), 0, 1), endDate: now };

    case 'lastYear':
      return {
        startDate: new Date(new Date().getFullYear() - 1, 0, 1),
        endDate: new Date(new Date().getFullYear() - 1, 11, 31, 23, 59, 59),
      };

    default:
      return {
        startDate: new Date(),
        endDate: new Date(),
      };
  }
};

const getDatasetsAmount = (from: Date, to: Date, period: Period): number => {
  const oneHour = 1000 * 60 * 60;
  const oneDay = oneHour * 24;
  const oneWeek = oneDay * 7;
  const oneMonth = oneDay * 30;

  const timeDifference = to.getTime() - from.getTime();

  // using Math.ceil to always get at least one dataset
  switch (period) {
    case 'hour':
      return Math.ceil(timeDifference / oneHour);

    case 'day':
      return Math.ceil(timeDifference / oneDay);

    case 'week':
      return Math.ceil(timeDifference / oneWeek);

    case 'month':
      return Math.ceil(timeDifference / oneMonth);

    default:
      return Math.ceil(timeDifference / oneDay);
  }
};

export const isIntervalDisabled = (from: Date, to: Date, period: Period): boolean => {
  const TEN_K = 10000;
  const FIVE_HUNDRED = 500;

  if (from && to) {
    const amountOfDatasets = getDatasetsAmount(from, to, period);
    if (period === 'day') {
      return amountOfDatasets >= TEN_K;
    }

    return amountOfDatasets >= FIVE_HUNDRED;
  }
  return true;
};

export const calculateYearRange = ({ from, to }: { from: Date; to: Date }): number[] => {
  const fromYear = from.getFullYear();
  const toYear = to.getFullYear();

  if (fromYear === toYear) {
    return [fromYear - 1, fromYear];
  }

  const diff = toYear - fromYear;

  return [
    fromYear,
    ...Array(diff)
      .fill(null)
      .map((_, idx) => fromYear + idx + 1),
  ];
};
